module.exports = __webpack_public_path__ + "static/media/slab.5eb20454.svg";